/* DON'T EDIT THIS FILE: edit original and run build again */ import {
  getAllTenantCodes,
  getTenantIndexEntry,
  TenantIndex,
} from "../../framework/tenant-collection/tenant-index-entry.ts";
import { getRealmUrlParts } from "./get-realm-url-parts.ts";

let realmsByHostAlone: { [host: string]: string };

const buildRealmsByHostAlone = (
  tenantIndex: TenantIndex,
  configGetter?: () => any
) => {
  const realmsByHostAlone: { [host: string]: string } = {};
  for (const tenant of getAllTenantCodes(tenantIndex)) {
    const { pathname, hostname } = getRealmUrlParts(
      tenant,
      getTenantIndexEntry(tenantIndex, tenant).getPathLabel(),
      configGetter
    );
    if (pathname === "") {
      realmsByHostAlone[hostname] = tenant;
    }
  }
  return realmsByHostAlone;
};

/** only for tenants that don't use paths */
export const getRealmsByHostAlone = (
  tenantIndex: TenantIndex,
  configGetter?: () => any
) => {
  if (configGetter) {
    return buildRealmsByHostAlone(tenantIndex, configGetter);
  }
  if (!realmsByHostAlone) {
    realmsByHostAlone = buildRealmsByHostAlone(tenantIndex);
  }
  return realmsByHostAlone;
};
